import {Component, Input} from '@angular/core';
import {ClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";

@Component({
  selector: 'app-calculated-logic',
  templateUrl: './calculated-logic.component.html',
  styleUrl: './calculated-logic.component.scss'
})
export class CalculatedLogicComponent {
  @Input() claimDto!: ClaimDto;
}
